// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:11:04

export default {
  "id": "zombie-chase",
  "slug": "zombie-chase",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/453535db3bbb4466847048a8a2686d5d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/453535db3bbb4466847048a8a2686d5d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Zombie Chase",
      "description": "In Zombie Chase, players navigate a chaotic world filled with the undead, using every ounce of strategic prowess to outlast the apocalypse. This is not a typical racing game, youll need to manage resources and make smart decisions to survive the relentless zombie hordes. Your brain isnt just a desirable snack for zombies in this game - its your greatest weapon!",
      "instructions": "Using your mouse or touchscreen controls, steer your character through the grid-based game world, avoiding zombies and collecting resources as you go. You can also set traps for zombies, but be careful not to get cornered yourself. Progress in the game re",
      "genres": [
        "Cards"
      ],
      "tags": [
        "3players",
        "combat",
        "platformer",
        "run",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "僵尸追逐",
      "description": "在《僵尸追逐》中，玩家在充满不死生物的混乱世界中穿梭，运用全部的战略智慧来度过末日。这不是一款典型的赛车游戏，你需要管理资源，做出明智的决定，才能在无情的僵尸群中生存下来。在这款游戏中，你的大脑不仅仅是僵尸渴望的美食，更是你最大的武器！",
      "instructions": "使用您的鼠标或触摸屏控制，引导您的角色在基于网格的游戏世界中前进，避开僵尸并收集资源。您还可以为僵尸设置陷阱，但请注意不要让自己陷入困境。游戏进度将...",
      "genres": [
        "卡牌"
      ],
      "tags": [
        "3人",
        "战斗",
        "平台游戏",
        "奔跑",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "僵屍追逐",
      "description": "在《僵尸追逐》中，玩家將穿梭於充滿僵屍的混亂世界，運用所有策略技巧來超越末日。這不是一個典型的賽車遊戲，你需要管理資源並做出明智的決策，才能在無情的僵屍群中倖存。在這個遊戲中，你的大腦不只是僵屍喜歡的美食，更是你最強大的武器！",
      "instructions": "使用滑鼠或觸控屏控制，引導你的角色穿越網格式的遊戲世界，避開僵尸並在行進中收集資源。你還可以設置陷阱捕捉僵尸，但請小心不要讓自己陷入絕境。遊戲進度會...",
      "genres": [
        "牌"
      ],
      "tags": [
        "3人遊戲",
        "戰鬥",
        "平台遊戲",
        "奔跑",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "僵屍追擊",
      "description": "在《僵尸追擊》中，玩家需在充滿不死生物的混亂世界中尋找方向，運用所有策略技巧以延長末日存續時間。這不是一個典型的賽車遊戲，你需要管理資源並做出明智的決策以逃離無敵的僵尸群眾。在這個遊戲中，你的腦子不只是僵尸渴望的美食，更是你最強大的武器！",
      "instructions": "使用你的滑鼠或觸控螢幕操控，引導你的角色穿越格線式遊戲世界，避開僵屍並在行進中收集資源。你還可以設置陷阱捕捉僵屍，但請小心不要讓自己陷入絕境。遊戲進度會...",
      "genres": [
        "牌"
      ],
      "tags": [
        "3人遊戲",
        "戰鬥",
        "平台遊戲",
        "奔跑",
        "僵屍"
      ]
    },
    "ja": {
      "title": "ゾンビ・チェイス",
      "description": "ゾンビチェースで、プレイヤーは混乱するゾンビ満載の世界を進み、大災害を生き延びるためにすべての戦略的スキルを使います。これは通常のレースゲームではありません。資源を管理し、賢明な決断を下すことで、絶え間なく襲ってくるゾンビ群を生き延びることが必要です。このゲームでは、あなたの脳はゾンビにとってただの美味しいごちそうではなく、最も強力な武器です！",
      "instructions": "マウスやタッチスクリーンコントロールを使用して、キャラクターをグリッドベースのゲームワールドを進め、ゾンビを避けながら資源を収集します。また、ゾンビに対する罠を設置することもできますが、自分が孤立しないように注意してください。ゲームの進行度",
      "genres": [
        "カード"
      ],
      "tags": [
        "3人",
        "戦闘",
        "プラットフォーム",
        "走る",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "죽은자의 추격",
      "description": "《僵尸追击》에서 플레이어들은 시체들이 가득한 혼란스러운 세계를 돌아다니며 전략적 지혜를 발휘하여 지옥을 벗어나는 것을 목표로 합니다. 이것은 일반적인 레이싱 게임이 아닙니다. 자원을 관리하고 지혜로운 결정을 내려 끊임없이 써들아오는僵尸军团을 피해야 합니다. 이 게임에서 머리는 단순히僵尸들에게서 희망하는 먹거리가 아니라 최대의 무기입니다!",
      "instructions": "마우스나 태스치스크린 컨트롤을 사용하여 캐릭터를 그리드 기반의 게임 세계로 이동시키고, 다니면서 죽은자와 자원을 수집하세요. 또한 죽은자를 위한 유치장을 설정할 수 있지만, 자신이 골도에 갇히지 않도록 주의하세요. 게임의 진행을 재",
      "genres": [
        "카드"
      ],
      "tags": [
        "3플레이어",
        "전투",
        "플랫폼 게임",
        "달리기",
        "죽음의 땅"
      ]
    },
    "fr": {
      "title": "Chasse de zombies",
      "description": "Dans Zombie Chase, les joueurs naviguent dans un monde chaotique peuplé de morts-vivants, utilisant chaque once de leur habileté stratégique pour survivre à l'apocalypse. Ce n'est pas un jeu de course typique ; vous devrez gérer les ressources et prendre des décisions intelligentes pour survivre aux hordes de zombies déchaînés. Votre cerveau n'est pas seulement un en-cas désirable pour les zombies dans ce jeu - c'est votre arme la plus puissante !",
      "instructions": "Utilisez votre souris ou les commandes de votre écran tactile pour diriger votre personnage à travers le monde de jeu basé sur une grille, évitant les zombies tout en collectant des ressources en chemin. Vous pouvez également installer des pièges pour les zombies, mais soyez prudent de ne pas vous faire piéger vous-même. Progresser dans le jeu vous permet de déverrouiller de nouveaux contenus.",
      "genres": [
        "Cartes"
      ],
      "tags": [
        "3 joueurs",
        "combat",
        "plate-forme",
        "course",
        "zombie"
      ]
    }
  }
};
